export default
    [
        {
            step: "details",
            path: "/facilities-managers/:facilitiesManagerId/details", 
            dataPath: "details",
            start: true
        },
        {
            step: "contact",
            path: "/facilities-managers/:facilitiesManagerId/contact",
            dataPath: "contact"
        },
        {
            step: "files",
            path: "/facilities-managers/:facilitiesManagerId/files",
            dataPath: "files"
        },
        {
            step: "complete",
            path: "/facilities-managers/:facilitiesManagerId/complete",
            dataPath: "complete",
            end: true
        }
    ];